import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CasesSection from './components/CasesSection';
import RoadmapSection from './components/RoadmapSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';

export default function Home() {
  const [loading, setLoading] = useState(() => {
    // 如果已经看过加载动画（来自子页面返回），直接跳过
    return !sessionStorage.getItem('pm_loaded');
  });

  const handleLoadComplete = () => {
    sessionStorage.setItem('pm_loaded', '1');
    setLoading(false);
  };

  return (
    <>
      {loading && <LoadingScreen onComplete={handleLoadComplete} />}
      <div
        className="relative bg-[#0a0118] min-h-screen"
        style={{
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.6s ease',
        }}
      >
        <Navbar />
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CasesSection />
        <RoadmapSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
}
